module.exports = __webpack_public_path__ + "static/assets/86c9a0665e8b9862407047bcb9f3db7e.svg";